import { AnalyticsEvent } from '../../core/AnalyticsEvent'
import { SearchStartEventSchema } from '../../schemas/search/SearchStartEventSchema'
import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'
import { CommonEventParams, getCommonParams } from '../../utils/CommonParams'
const GROCERY = 'grocery'

export interface UserStartSearchEventParams extends CommonEventParams {
  BUSINESS_VERTICAL: string
  EVENT_CATEGORY: string
  SEARCH_SUGGESTED_CAMPAIGN_NAME: string[]
  SEARCH_SUGGESTED_CAMPAIGN_NAME_COUNT: number
  SEARCH_POPULAR_CATEGORY_KEYWORDS: string[]
  SEARCH_POPULAR_CATEGORY_KEYWORDS_COUNT: number
  SEARCH_RECENT_KEYWORDS: string[]
  SEARCH_RECENT_KEYWORDS_COUNT: number
  SEARCH_AUTOCOMPLETE_KEYWORDS: string[]
  SEARCH_AUTOCOMPLETE_KEYWORDS_COUNT: number
  SEARCH_TRENDING_KEYWORDS: string[]
  SEARCH_TRENDING_KEYWORDS_COUNT: number
  SEARCH_TERM: string
  SEARCH_TERM_TYPED: string
  SEARCH_SEGMENTS: string
}

export class SearchStartEvent extends AnalyticsEvent {
  constructor(params: UserStartSearchEventParams) {
    super(SearchStartEventSchema(), ['segment'])
    this.createEventObject(params)
  }
}

export async function trackSearchStartEvent(
  startSearchParams: UserStartSearchEventParams
): Promise<void> {
  startSearchParams.BUSINESS_VERTICAL = startSearchParams.EVENT_CATEGORY =
    GROCERY
  const config = getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_TWO) || {}
  const { isEnabled = false } = config
  if (isEnabled) {
    const params: UserStartSearchEventParams = {
      ...getCommonParams(),
      ...startSearchParams,
    }
    new SearchStartEvent(params).track()
  }
}
